/**
 * Admin panel date formatting: treat server datetimes as UTC (MySQL sends no timezone),
 * display in Eastern Time (America/New_York) with " ET" suffix.
 */

const EST_TZ = 'America/New_York'

/**
 * Parse a server datetime string as UTC. Server sends MySQL datetime without timezone (e.g. "2026-03-06 22:27:54").
 * If the string has no Z or ±HH:MM, append Z so it's interpreted as UTC.
 */
export function parseDateAsUtc(value: string | null | undefined): Date | null {
  if (!value || typeof value !== 'string') return null
  const s = value.trim()
  if (!s) return null
  if (s.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s)
  const iso = s.replace(' ', 'T') + 'Z'
  const d = new Date(iso)
  return isNaN(d.getTime()) ? new Date(s) : d
}

/** Format as date + time in Eastern (e.g. "3/6/26, 5:27:54 PM ET"). */
export function formatDateTimeEST(value: string | null | undefined): string {
  const d = parseDateAsUtc(value)
  if (!d) return '—'
  return `${d.toLocaleString('en-US', { timeZone: EST_TZ, dateStyle: 'short', timeStyle: 'medium' })} ET`
}

/** Format as date only in Eastern (e.g. "3/6/26 ET" or "Mar 6, 2026"). */
export function formatDateEST(value: string | null | undefined, style: 'short' | 'medium' = 'short'): string {
  const d = parseDateAsUtc(value)
  if (!d) return '—'
  if (style === 'medium') {
    return `${d.toLocaleDateString('en-US', { timeZone: EST_TZ, year: 'numeric', month: 'short', day: 'numeric' })} ET`
  }
  return `${d.toLocaleDateString('en-US', { timeZone: EST_TZ, dateStyle: 'short' })} ET`
}
